<template>
  <div>
    <modal
      name="modal-confirm-sales-products"
      :width="`90%`"
      :height="`auto`"
      scrollable
    >
      <v-card class="confirm-sales-products">
        <v-card-text>
          <div class="confirm-sales-products__table">
            <div class="confirm-sales-products__header">
              <span class="confirm-sales-products__header-product">
                {{ $t('PRODUCT') }}
              </span>
              <span class="confirm-sales-products__header-units">
                {{ $t('UNIDADES') }}
              </span>
            </div>
            <div
              v-for="(item, index) in localItems"
              :key="index"
              class="confirm-sales-products__row"
            >
              <span class="confirm-sales-products__product">{{ item.product }}</span>
              <span class="confirm-sales-products__units">{{ item.units }}</span>
            </div>
            <div
              v-if="!localItems || localItems.length === 0"
              class="confirm-sales-products__empty"
            >
              {{ $t('No data available') }}
            </div>
          </div>
          <div class="confirm-sales-products__comments">
            <label class="confirm-sales-products__comments-label">
              {{ $t('Comments about the order:') }}
            </label>
            <v-textarea
              v-model="localComments"
              outlined
              hide-details
              auto-grow
              :placeholder="$t('Add any comments about this sales order...')"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions class="confirm-sales-products__actions">
          <v-spacer></v-spacer>
          <v-btn
            class="confirm-sales-products__back"
            color="#a94717"
            dark
            @click="onClickBack"
          >
            {{ $t('Back') }}
          </v-btn>
          <v-btn
            class="confirm-sales-products__ok"
            color="#3c8d1e"
            dark
            @click="onClickOk"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </modal>
  </div>
</template>

<script>
export default {
  name: "ConfirmSalesProducts",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localItems: [],
      localComments: ""
    };
  },
  watch: {
    items: {
      handler(newItems) {
        this.localItems = newItems && newItems.length > 0 ? newItems : [];
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Show the modal with items and comments
     * @param {Object} payload - { items: Array, comments: String }
     */
    showModal(payload = {}) {
      const { items = this.items, comments = "" } = payload || {};
      
      // Set the items to display in the modal
      this.localItems = items && items.length > 0 ? items : [];
      
      // Set initial comments
      this.localComments = comments;
      
      // Show the modal
      this.$modal.show("modal-confirm-sales-products");
    },

    /**
     * Hide the modal
     */
    hideModal() {
      this.$modal.hide("modal-confirm-sales-products");
    },

    /**
     * Handle OK button click
     * Emits 'confirm' event with comments and items data
     */
    onClickOk() {
      this.$emit("confirm", {
        comments: this.localComments,
        items: this.localItems
      });
      this.hideModal();
    },

    /**
     * Handle Back button click
     * Emits 'cancel' event and closes modal
     */
    onClickBack() {
      this.$emit("cancel", {
        comments: this.localComments,
        items: this.localItems
      });
      this.hideModal();
    },

    /**
     * Reset the modal data
     */
    resetModal() {
      this.localItems = [];
      this.localComments = "";
    }
  },

  /**
   * Clean up when component is destroyed
   */
  beforeDestroy() {
    this.hideModal();
  }
};
</script>

<style scoped>
.confirm-sales-products {
  padding-bottom: 16px;
  font-family: Arial, sans-serif;
}

.confirm-sales-products__table {
  border: 2px solid #000;
  padding: 24px 24px 16px;
  margin-bottom: 8px;
}

.confirm-sales-products__header {
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
  color: #333;
}

.confirm-sales-products__header-product {
  flex: 1 1 auto;
  margin-right: 16px;
}

.confirm-sales-products__header-units {
  flex: 0 0 80px;
  text-align: center;
}

.confirm-sales-products__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;;
}

.confirm-sales-products__row:last-child {
  margin-bottom: 0;
}

.confirm-sales-products__product {
  flex: 1 1 auto;
  margin-right: 16px;
  color: #000;
  line-height: 1.4;
  font: bold;
}

.confirm-sales-products__units {
  flex: 0 0 80px;
  text-align: center;
  font-weight: bold;
  color: #333;
}

.confirm-sales-products__empty {
  text-align: center;
  font-style: italic;
  padding: 32px 0;
  color: #666;
}

.confirm-sales-products__comments {
  margin-top: 24px;
  padding: 0 8px;
}

.confirm-sales-products__comments-label {
  display: block;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
}

.confirm-sales-products__actions {
  justify-content: flex-end;
  padding: 16px 24px 24px;
}

.confirm-sales-products__back {
  margin-right: 16px !important;
  min-width: 80px;
  font-weight: bold;
}

.confirm-sales-products__ok {
  min-width: 80px;
  font-weight: bold;
}

/* Custom scrollbar for the modal */
.confirm-sales-products__table::-webkit-scrollbar {
  width: 6px;
}

.confirm-sales-products__table::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.confirm-sales-products__table::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.confirm-sales-products__table::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .confirm-sales-products__table {
    padding: 16px;
  }
  
  .confirm-sales-products__header,
  .confirm-sales-products__row {
    font-size: 13px;
  }
  
  .confirm-sales-products__product {
    margin-right: 8px;
  }
  
  .confirm-sales-products__units {
    flex: 0 0 60px;
  }
  
  .confirm-sales-products__actions {
    padding: 12px 16px 20px;
  }
}
</style>